









import Vue from 'vue';

import { RouteType } from './constants';

export default Vue.extend({
	name: 'CustomLink',
	props: {
		route: { type: [Object, String], required: true },
		routeType: { type: Number as () => RouteType, required: true },
		newTab: { type: Boolean, default: false },
	},
	data() {
		return {
			RouteType,
		};
	},
	computed: {
		isUrl(): boolean {
			return this.routeType === RouteType.url;
		},
	},
});
